import styled from '@emotion/styled';
import { ProjectProgressSummary } from '@kaizenplatform/hugot-entity';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import mq from '../../../styleUtility/mediaquery';

export interface Props {
  summary?: ProjectProgressSummary;
  className?: string;
}

const ProgressSummary = ({ summary, className }: ClassAttributes<HTMLElement> & Props) => {
  if (summary) {
    return (
      <Root className={className}>
        <Column>
          <Label>
            <FormattedMessage id="projects_list.progress_summary.order_count" />
          </Label>
          <Value>{summary.orderCount}</Value>
        </Column>
        <Column>
          <Label>
            <FormattedMessage id="projects_list.progress_summary.approved_count" />
          </Label>
          <Value style={{ color: '#6bb052' }}>{summary.approvedCount === 0 ? '-' : summary.approvedCount}</Value>
        </Column>
        <Column>
          <Label>
            <FormattedMessage id="projects_list.progress_summary.modification_request_count" />
          </Label>
          <Value style={{ color: '#e35f61' }}>
            {summary.modificationRequestCount === 0 ? '-' : summary.modificationRequestCount}
          </Value>
        </Column>
      </Root>
    );
  } else {
    return null;
  }
};

const Root = styled('div')({
  ...flexibleLayoutContainer({
    direction: 'row',
    wrap: 'wrap',
  }),
});

const Column = styled('div')({
  ...flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
  }),
  minWidth: 70,
  marginRight: SPACING_UNIT * 3,
  marginLeft: SPACING_UNIT * 3,
  [mq('sp')]: {
    marginRight: SPACING_UNIT / 2,
    marginLeft: SPACING_UNIT / 2,
  },
});

const Label = styled(Typography)({
  marginBottom: SPACING_UNIT,
  whiteSpace: 'nowrap',
});
Label.defaultProps = { variant: 'caption' };

const Value = styled(Typography)({
  fontSize: 16,
  fontWeight: 700,
});

export default ProgressSummary;
